import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { uploadDocApis } from '../../constants/upload-doc-api';

@Injectable({
    providedIn: 'root',
})
export class UploadDocService {
    constructor(private httpClientService: HttpClientService) {}

    getUploadDoc(user_id: any, pagination?: any): Observable<any> {
        let url = `${uploadDocApis.getUploadDoc}${user_id}`;
    
        if (pagination?.skip != null && pagination?.limit != null) {
            const queryParams = `&skip=${pagination.skip}&limit=${pagination.limit}`;
            url += queryParams;
        }
    
        return this.httpClientService.get(url);
    }
    
    

    postUploadDoc(payload: any): Observable<any> {
        return this.httpClientService.upload(
            uploadDocApis.createUploadDoc,
            payload
        );
    }

    editUploadDoc(payload: any): Observable<any> {
        return this.httpClientService.put(uploadDocApis.editUploadDoc, payload);
    }

    deleteUploadDoc(id: string): Observable<any> {
        return this.httpClientService.delete(
            `${uploadDocApis.deleteUploadDoc}?id=${id}`
        );
    }
}
